import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['submit'];

	connect() {
		this.element.addEventListener('submit', this.handleSubmit.bind(this));
	}

	handleSubmit() {
		if (!this.hasSubmitTarget) return;
		this.submitTarget.disabled = true;
		const span = this.submitTarget.querySelector('span');
		const newText = this.submitTarget.dataset.trans;
		if (span && newText) {
			span.textContent = newText + '...';
		}
	}
}
